import React, { useEffect, useMemo, useRef, useState } from "react";
import DropdownMenu from "../DropDownMenu/dropdownmenu";

export const REPORT_TABLE_ACTIONS_COLUMN = "rowActions";

export const isReportTableActionsColumn = (field) =>
  field === REPORT_TABLE_ACTIONS_COLUMN ||
  field === "Actions" ||
  field === "actions";

function buildMenuItems(row, actions) {
  const visibleActions = (actions || []).filter((action) => {
    if (typeof action.visible === "function" && !action.visible(row)) {
      return false;
    }
    if (typeof action.disabled === "function" && action.disabled(row)) {
      return false;
    }
    if (action.disabled === true) return false;
    return true;
  });

  const menuItems = [];
  visibleActions.forEach((action) => {
    if (action.dividerBefore && menuItems.length > 0) {
      menuItems.push({ divider: true });
    }
    menuItems.push({
      label: typeof action.label === "function" ? action.label(row) : action.label,
      icon: typeof action.icon === "function" ? action.icon(row) : action.icon,
      dataTour:
        typeof action.dataTour === "function"
          ? action.dataTour(row)
          : action.dataTour,
      onClick: () => action.onClick?.(row),
    });
  });
  return menuItems;
}

/**
 * Compact fixed-size ⋮ trigger + dropdown for ReportTable action columns.
 * Pass either `actions` + `row`, or prebuilt `items`.
 */
const ReportTableRowActions = ({
  row,
  actions = [],
  items: itemsProp,
  ariaLabel = "Row actions",
  title = "Actions",
  dataTour,
  forceShow = false,
  menuZIndex,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const triggerRef = useRef(null);

  const items = useMemo(() => {
    if (Array.isArray(itemsProp)) return itemsProp;
    return buildMenuItems(row, actions);
  }, [actions, itemsProp, row]);

  useEffect(() => {
    if (forceShow) setShowMenu(true);
    else setShowMenu(false);
  }, [forceShow]);

  if (!items.length) return null;

  const open = forceShow || showMenu;

  return (
    <div className="report-table__row-actions">
      <button
        ref={triggerRef}
        type="button"
        className="btn btn-sm btn-outline-secondary report-table__row-actions-trigger"
        data-tour={dataTour || undefined}
        onClick={() => {
          if (forceShow) return;
          setShowMenu((prev) => !prev);
        }}
        aria-label={ariaLabel}
        title={title}
        aria-expanded={open}
      >
        <i className="fas fa-ellipsis-v" aria-hidden="true" />
      </button>
      <DropdownMenu
        items={items}
        show={open}
        onClose={() => {
          if (forceShow) return;
          setShowMenu(false);
        }}
        trigger={triggerRef}
        align="end"
        zIndex={menuZIndex || 1400}
      />
    </div>
  );
};

export default ReportTableRowActions;
